import React from 'react';
// 兼容IE浏览器, 请放在最上面否则不生效
import commonStore from './common';
import slideVerificationStore from './slideVerification';
import './utils';

// https://mobx-react.js.org/recipes-context#multiple-global-stores
export const storesContext = React.createContext({
  commonStore,
  slideVerificationStore,
});
